<template>
  <div class="title" :class="{miniWrap: platform}">
    <div class="left">
      <img :src="logo" alt="logo" class="logo" @click="initPage">
      <span>{{ name === 3 ? '支付中心' : ''}}</span>
    </div>
    <ul class="right">
      <li :class="{active: name == 1}" @click="setTab(1)" v-show="name != 3">首页</li>
      <!-- <li :class="{active: name == 2}" @click="setTab(2)" v-show="name != 3">经销商</li> -->
      <li :class="{active: name == 4}" @click="setTab(4)" v-show="name != 3">饷店功能服务</li>
      <!-- <li :class="{active: name == 5}" @click="setTab(5)" v-show="name != 3">关于我们</li> -->
      <!-- <li :class="{active: name == 6}" @click="userOperate()" class="operate-menu">
        <span class="text" :class="{active: name == 7}">{{userInfo.userPhone ? (userInfo.userPhone || userInfo.userName) : '登录/注册' }}</span>
        <span class="arrow" :class="{down: (userInfo.userId && showTarget)}" v-show="userInfo.userId"></span>
        <div class="user-operate" v-show="userInfo.userId && showTarget">
          <p @click="myOrder">我的订单</p>
          <p @click="quit">退出</p>
        </div>
      </li> -->
    </ul>
  </div>
</template>

<script>
import { getGodds } from 'api/http'
import { mapState, mapMutations } from 'vuex'
import logo from 'common/img/new/logo.png'
export default {
  name: 'Head',
  data() {
    return {
      showTarget: false,          // 展示用户操作面板
      logo: logo
    }
  },
  computed: {
    ...mapState([
      'name',
      'platform',
      'userInfo'
    ])
  },
  created() {
    this.setUserInfo()
    this.getGoddsPrice()
  },
  mounted() {
    this.jumpToH5()
  },
  methods: {
    ...mapMutations(['setName', 'setUserInfo', 'setLoginWrap', 'setLoginOutWrap', 'setPrice']),
    setTab(index) {
      this.setName(index)
      let pathArr = ['/', 'city', 'activity', 'shop', 'about']
      this.$router.push(pathArr[index - 1])
    },
    tabToggle() {
      this.showTabs = !this.showTabs
    },
    userOperate() {
      let that = this
      if(that.userInfo.userId) {
        that.showTarget = !that.showTarget
      }else {
        this.setLoginWrap(true)
      }
    },
    myOrder() {
      this.$router.push('/myorder')
    },
    quit() {
      this.$track.sendLog('click', {
        spm: '3.1969'
      })
      this.setLoginOutWrap(true)
    },
    initPage() {
      this.$router.push('/')
    },
    getGoddsPrice() {
      let that = this
      getGodds({
        goodsCode: "AKCXD001"
      }).then(res=> {
        if(res.data) {
          let price = (res.data.goodsPrice/100) > 1 ? parseInt(res.data.goodsPrice/100) : (res.data.goodsPrice/100).toFixed(2)
          that.setPrice(price)
        }
      }).catch(er=> {
        console.log('获取商品信息Error：', er)
      })
    },
    jumpToH5() {
      const testUrl = `http://sharing-h5.akctest1.com`
      const prodUrl = `https://h5.xiangdian.shop`
      const host = window.location.host;
      if (!host.includes('xiangdian.shop')) {
        return;
      }
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        if(process.env.NODE_ENV == 'production') {
          window.location.href = prodUrl
        }else {
          window.location.href = testUrl
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.title {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 100;
  width: 1000px;
  min-width: 1000px;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-bottom: solid 1px #E6E6E6;
  .left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .logo {
      width: 133px;
      height: 40px;
    }
    span {
      font-size:16px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
      margin-left: 20px;
    }
  }
  .right {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    li {
      font-size: 16px;
      padding: 0 20px;
      height: 100%;
      line-height: 60px;
      font-family: PingFangSC-Regular, sans-serif;
      cursor: pointer;
      &:hover {
        color: #EC2232;
      }
      &.active {
        color: #EC2232;
      }
      &:nth-child(2) {
        padding-right: 0;
      }

      .text {
        max-width: 170px;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: #999;
        font-size: 14px;
        padding-left: 56px;
        &.active {
          color: #EC2232;
        }
      }
      .arrow {
        width: 7px;
        height: 4px;
        background-image: url('../common/img/arrow.png');
        background-size: 100% 100%;
        display: inline-block;
        &.down {
          transform: rotate(180deg);
        }
      }
      .user-operate {
        width: 98px;
        height: 70px;
        background-image: url('../common/img/operate.png');
        background-size: 100% 100%;
        line-height: 30px;
        position: fixed;
        z-index: 100;
        top: 42px;
        right: -1px;
        padding: 7px 0;
        p {
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:#333;
          &.active {
            color: #EC2232;
          }
        }
      }

      &.operate-menu {
        max-width: 170px;
        padding: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
}
</style>
